import React, { SyntheticEvent } from 'react';
import { PlateSizeHeading, PlateSizeTitle, PlateSizeSubtitle, MessagePlateSectionContainer, KpPlateMessageInput, LockedMessageSpacing } from './PlateDesignDetails.styles';
import { TextColor } from '~/dataModels/ProductModels';
import { TextColorPalette } from '@components/PlateColorPalette';

interface LockedMessagePlateSectionProps {
    titleTop: string
    titleBottom: string
    subtitleTop?: number
    subtitleBottom?: number
    colorTitle: string
    plateMessageColors: TextColor[]
    currentTextColor?: TextColor
    currentTextTop: string
    currentTextBottom: string
    handleColorChange: (data: TextColor) => void
    handleMessageTopTextChange: (event: SyntheticEvent<HTMLElement, Event>, data: { value: string }) => void
    handleMessageBottomTextChange: (event: SyntheticEvent<HTMLElement, Event>, data: { value: string }) => void
    darkTheme: boolean
}


export const LockedMessagePlateSection = ({ titleTop, titleBottom, subtitleTop, subtitleBottom, colorTitle, plateMessageColors, currentTextColor, currentTextTop, currentTextBottom, handleColorChange, handleMessageTopTextChange, handleMessageBottomTextChange, darkTheme }: LockedMessagePlateSectionProps) => {
    const selectedTextColor = currentTextColor === undefined ? plateMessageColors[0] : currentTextColor;


    return (<MessagePlateSectionContainer>
        <PlateSizeHeading>
            <PlateSizeTitle darkTheme={darkTheme}>{titleTop}</PlateSizeTitle>
            <PlateSizeSubtitle darkTheme={darkTheme}>{subtitleTop}mm Remaining</PlateSizeSubtitle>
        </PlateSizeHeading>
        <KpPlateMessageInput placeholder="ENTER A MESSAGE" fluid value={currentTextTop} onChange={handleMessageTopTextChange} />
        <LockedMessageSpacing />
        <PlateSizeHeading>
            <PlateSizeTitle darkTheme={darkTheme}>{titleBottom}</PlateSizeTitle>
            <PlateSizeSubtitle darkTheme={darkTheme}>{subtitleBottom}mm Remaining</PlateSizeSubtitle>
        </PlateSizeHeading>
        <KpPlateMessageInput placeholder="ENTER A MESSAGE" fluid value={currentTextBottom} onChange={handleMessageBottomTextChange} />
        {
            plateMessageColors && plateMessageColors.length > 1 &&
            <TextColorPalette
                colors={plateMessageColors}
                selectedColor={selectedTextColor}
                title={colorTitle}
                handleColorChange={handleColorChange} 
                darkTheme={darkTheme}/>
        }
    </MessagePlateSectionContainer>);
};